export { createI18nMock } from './i18nMock';
export { init18n } from './i18n';
export * from './main';
